import { render, staticRenderFns } from "./ResComplexFrame.vue?vue&type=template&id=83222804&"
import script from "./ResComplexFrame.vue?vue&type=script&lang=js&"
export * from "./ResComplexFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports